(() => {
  if (window.__vrWhyMediaReady) return;
  window.__vrWhyMediaReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const managedVideos = new Set();
  let observer;

  const canAutoplay = () =>
    !reduceMotion.matches &&
    !navigator.connection?.saveData &&
    !document.hidden;

  const safePlay = (video) => {
    if (!canAutoplay() || video.dataset.vrxInViewport === 'false') return;
    video.play()?.catch(() => {});
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const visible = entry.isIntersecting && entry.intersectionRatio >= 0.08;
          video.dataset.vrxInViewport = visible ? 'true' : 'false';
          if (visible) safePlay(video);
          else video.pause();
        });
      },
      { threshold: [0, 0.08, 0.25] }
    );
    return observer;
  };

  const insertWhyVideo = (root) => {
    const media = root.querySelector('.vrx-why__image');
    const config = document.querySelector('.vr-live-patch[data-vrx-why-video]');
    if (!media || !config || media.querySelector('[data-vrx-why-video-element]')) return;

    const sourceUrl = config.dataset.vrxWhyVideo;
    const posterUrl = config.dataset.vrxWhyPoster;
    const currentImage = media.querySelector('img');
    if (!sourceUrl || !posterUrl || !currentImage) return;

    if (reduceMotion.matches || navigator.connection?.saveData) {
      currentImage.src = posterUrl;
      currentImage.removeAttribute('srcset');
      currentImage.width = 720;
      currentImage.height = 1280;
      return;
    }

    const video = document.createElement('video');
    video.className = 'vrx-why__video';
    video.dataset.vrxWhyVideoElement = 'true';
    video.width = 720;
    video.height = 1280;
    video.poster = posterUrl;
    video.preload = 'metadata';
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');

    const source = document.createElement('source');
    source.src = sourceUrl;
    source.type = 'video/mp4';
    video.append(source);

    currentImage.replaceWith(video);
    managedVideos.add(video);
    const videoObserver = getObserver();
    if (videoObserver) videoObserver.observe(video);
    else {
      video.dataset.vrxInViewport = 'true';
      safePlay(video);
    }
  };

  const addHeroMarquee = (root) => {
    if (root.querySelector('.vrx-marquee--hero')) return;
    const hero = root.querySelector('.vrx-hero');
    if (!hero) return;

    const labels = [
      'COLD-PRESSED OILS',
      'TEL PAKA VIDHI',
      'TRIPLE FILTRATION',
      'VETIVER ROOT FINISH',
      'SMALL-BATCH CRAFTED',
      'BOTANICAL SCALP CARE'
    ];
    const marquee = document.createElement('div');
    marquee.className = 'vrx-marquee vrx-marquee--hero';
    marquee.setAttribute('aria-hidden', 'true');
    const track = document.createElement('div');
    [...labels, ...labels].forEach((label) => {
      const text = document.createElement('span');
      text.textContent = label;
      const divider = document.createElement('i');
      divider.textContent = '✦';
      track.append(text, divider);
    });
    marquee.append(track);
    hero.insertAdjacentElement('afterend', marquee);
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('[data-vrx]')
      ? [scope]
      : [...(scope.querySelectorAll?.('[data-vrx]') || [])];
    roots.forEach((root) => {
      if (root.dataset.vrxMediaReady === 'true') return;
      root.dataset.vrxMediaReady = 'true';
      addHeroMarquee(root);
      insertWhyVideo(root);
      root.querySelector('.vrx-hero .vrx-mini-price')?.classList.add('vrx-mini-price--offer');
    });
  };

  const syncVideos = () => {
    managedVideos.forEach((video) => {
      if (!video.isConnected) {
        managedVideos.delete(video);
        return;
      }
      if (canAutoplay() && video.dataset.vrxInViewport !== 'false') safePlay(video);
      else video.pause();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('visibilitychange', syncVideos);
  reduceMotion.addEventListener?.('change', syncVideos);
})();
